import React from 'react'
import { Controller, Control } from 'react-hook-form'
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap'

interface Props {
  name: string
  label: string
  control: Control<any>
  placeholder?: string
  rows?: number
}

const ICSTextArea = ({
  name,
  label,
  control,
  placeholder,
  rows = 3
}: Props) => (
  <FormGroup>
    <Label for={name}>{label}</Label>
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <>
          <Input
            id={name}
            type="textarea"
            {...field}
            rows={rows}
            placeholder={placeholder || `${label}...`}
            invalid={!!fieldState.error}
          />
          {fieldState.error && (
            <FormFeedback>{fieldState.error.message}</FormFeedback>
          )}
        </>
      )}
    />
  </FormGroup>
)

export default ICSTextArea
